/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_AnonymizeInputs */



/**
* | output |
* | --- |
* | "Anonymize" |
*
* @param {Member_AnonymizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const member_anonymize = /** @type {((inputs?: Member_AnonymizeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_AnonymizeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Anonymiser")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anonimizar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Anonimizar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anonimizza")
	return /** @type {LocalizedString} */ ("Anonymize")
});